import React, { Fragment, useState } from 'react';
import * as XLSX from "xlsx";
import { Button, Form, Alert, Col, Row, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ComponentesService from '../../../../services/componentes';


const FormImportComp = () => {
    const [dados, setDados] = useState([]);
    const [botao, setBotao] = useState(false);
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleFile = async (e) => {
        const arquivo = e.target.files[0];
        if (!arquivo) return;

        setBotao(true);   // bloquear botão
        const data = await arquivo.arrayBuffer();
        const workbook = XLSX.read(data);
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const json = XLSX.utils.sheet_to_json(sheet, { raw: false });
        const normalizados = json.map((linha) => ({
            nome: linha["nome"],
            categoria: linha["categoria"],
            tipo: linha["tipo"],
            modeloReferencia: linha["modeloReferencia"],
            descricao: linha["descricao"],
            especificacaoTecnica: linha["especificacaoTecnica"]
        }));
        setDados(normalizados);
        setBotao(false);  // liberar botão
    };

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        setLoading(true);
        if (dados.length === 0) {
            return setError("Nenhum dado encontrado na planilha.");
        }
        try {
            const func = await ComponentesService.cadastroMultiplo(dados)
            setLoading(false);
            if (func.data.length > 1) {
                setSucesso(true);
            }
            else {
                setError(func.data["erros"]);
            }
        } catch (error) {
            setLoading(false);
            setError("Deu algo errado no seu cadastro!")
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setError([]);
    }
    if (loading) {
        return (
            <Container className="text-center mt-5">
                <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status" />
                </div>
                <p className="mt-3">⏳ Cadastrando componentes em massa, aguarde...</p>
            </Container>
        );
    }
    if (!sucesso) {
        return (
            <Fragment>
                <Container>
                    <Row xs={1} lg={2}>
                        <Form onSubmit={HandleSubmit} >
                            <Row xs={1} lg={3}>
                                <Col lg={6}>
                                    <Form.Group className="mb-3" controlId="arquivo">
                                        <Form.Label>Planilha com componentes</Form.Label>
                                        <Form.Control
                                            required
                                            type="file"
                                            name="arquivo"
                                            onChange={handleFile}
                                            accept=".xlsx"

                                        />
                                    </Form.Group>
                                </Col>
                                {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                                <Col xs={12} lg={3}>
                                    <Button
                                        variant="success"
                                        className="alinha-botao"
                                        type="submit"
                                        disabled={botao || dados.length === 0}
                                    >
                                        {botao ? "Lendo planilha..." : "Importar"}
                                    </Button>
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                {dados.length > 0 && !botao && (
                                    <Alert variant="info">
                                        {dados.length} componentes carregados da planilha.
                                    </Alert>
                                )}
                                {error && error.length > 0 && (
                                    <Alert variant="danger">
                                        <ul>
                                            {error.map((item, index) => (
                                                <li key={index}>
                                                    {item.erro} — Componente: {item.dados.nome}
                                                </li>
                                            ))}
                                        </ul>
                                    </Alert>
                                )}
                            </Row>
                        </Form >
                    </Row>
                    <br/>
                    <Link to={'/ti/componentes'}>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </Link>
                    <br />
                </Container>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Alert variant='success'>Componentes importados com sucesso!</Alert>
                    <Button onClick={addNovo} variant="success" type="submit">
                        Importar mais!
                    </Button>
                    <br /><br />
                    <Link to={'/ti/componentes'}>
                        <Button variant="danger" type="button">
                            Voltar
                        </Button>
                    </Link>
                </Container>
            </Fragment>
        )
    }
}

export default FormImportComp;